import React from "react";
import "./Loader.css";
import { useTenant } from "../../TenantContext";

const Loader = () => {
  // Tenant logo when set, else the env/bundled fallback (see TenantContext).
  const { logo, tenant } = useTenant();
  return (
    <div className="loaderContainer">
      <div className="ott-loader">
        <img
          src={logo}
          alt={tenant?.name || process.env.REACT_APP_SITE_TITLE}
          className="ott-loader__logo"
        />
        <div className="ott-loader__ring" />
      </div>
    </div>
  );
};

export default Loader;
